// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"42":"20c90b254a42ed40106e","197":"2204f8c108663a44ceef"}[chunkId] + ".js";
};